import styled from 'styled-components'
import { FilterContainer } from '../styles'

export const EventFilterContainer = styled(FilterContainer)``
